import type { BuildingData } from "@/types/explore"
import { DataRow } from "./data-row"

const formatNumber = (n: number) => n.toLocaleString("fr-FR")

interface BuildingDetailsProps {
  buildingData: BuildingData[] | null
}

export const BuildingDetails = ({ buildingData }: BuildingDetailsProps) => {
  if (!buildingData || buildingData.length === 0) {
    return <div className="text-sm text-muted-foreground pt-2">Aucune donnée bâtiment disponible</div>
  }

  return (
    <div className="pt-1 space-y-3">
      {buildingData.map((building) => {
        const rows: [string, string | number][] = []
        if (building.hauteur_mean > 0) rows.push(["Hauteur", `${building.hauteur_mean}m`])
        if (building.nb_niveau > 0) rows.push(["Niveaux", building.nb_niveau])
        if (building.surface_emprise_sol > 0)
          rows.push(["Surface au sol", `${formatNumber(Math.round(building.surface_emprise_sol))} m²`])
        if (building.annee_construction) rows.push(["Année", building.annee_construction])
        if (building.usage_niveau_1_txt) rows.push(["Usage", building.usage_niveau_1_txt])
        if (building.mat_mur_txt) rows.push(["Murs", building.mat_mur_txt])
        if (building.mat_toit_txt) rows.push(["Toiture", building.mat_toit_txt])
        if (building.nb_log && building.nb_log > 0) rows.push(["Logements", building.nb_log])

        return (
          <div key={building.batiment_groupe_id}>
            {rows.map(([k, v]) => (
              <DataRow key={k} label={k} value={v} />
            ))}
          </div>
        )
      })}
    </div>
  )
}
